import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const MileageIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "MileageGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M18.7168 20.2734H14.9307C13.4853 20.2734 12.3096 19.0977 12.3096 17.6533V16.1602C12.3096 15.2666 11.5825 14.5391 10.689 14.5391H5.82324C5.54687 14.5391 5.32324 14.3154 5.32324 14.0391C5.32324 13.7627 5.54687 13.5391 5.82324 13.5391H10.689C12.1338 13.5391 13.3096 14.7149 13.3096 16.1602V17.6533C13.3096 18.5469 14.0366 19.2734 14.9307 19.2734H18.7168C18.9932 19.2734 19.2168 19.4971 19.2168 19.7734C19.2168 20.0498 18.9932 20.2734 18.7168 20.2734Z"
        fill="#696969"
      />
      <path
        d="M5.82324 8.9043C4.92724 8.9043 4.19873 8.17578 4.19873 7.2793C4.19873 6.38379 4.92725 5.65528 5.82324 5.65528C6.71875 5.65528 7.44726 6.3838 7.44726 7.2793C7.44726 8.17578 6.71874 8.9043 5.82324 8.9043ZM5.82324 6.65528C5.479 6.65528 5.19873 6.93555 5.19873 7.2793C5.19873 7.62403 5.479 7.9043 5.82324 7.9043C6.16748 7.9043 6.44726 7.62403 6.44726 7.2793C6.44726 6.93555 6.16747 6.65528 5.82324 6.65528Z"
        fill="#696969"
      />
      <path
        d="M5.82324 12.21C5.72705 12.21 5.63086 12.1826 5.54736 12.127C5.41357 12.0381 2.27002 9.92773 2.27002 7.27929C2.27002 5.32031 3.86377 3.72656 5.82324 3.72656C7.78222 3.72656 9.37597 5.32031 9.37597 7.27929C9.37597 9.92773 6.2329 12.0381 6.09911 12.127C6.01561 12.1826 5.91943 12.21 5.82324 12.21ZM5.82324 4.72656C4.41553 4.72656 3.27002 5.87207 3.27002 7.27929C3.27002 8.99023 5.11133 10.5527 5.82324 11.0928C6.53515 10.5527 8.37597 8.99023 8.37597 7.27929C8.37597 5.87206 7.23095 4.72656 5.82324 4.72656Z"
        fill="#696969"
      />
      <path
        d="M18.7168 14.6123C17.8208 14.6123 17.0923 13.8838 17.0923 12.9883C17.0923 12.0928 17.8208 11.3643 18.7168 11.3643C19.6128 11.3643 20.3413 12.0928 20.3413 12.9883C20.3413 13.8838 19.6128 14.6123 18.7168 14.6123ZM18.7168 12.3643C18.3725 12.3643 18.0923 12.6445 18.0923 12.9883C18.0923 13.332 18.3725 13.6123 18.7168 13.6123C19.061 13.6123 19.3413 13.332 19.3413 12.9883C19.3413 12.6445 19.061 12.3643 18.7168 12.3643Z"
        fill="#696969"
      />
      <path
        d="M18.7168 17.919C18.6206 17.919 18.5244 17.8916 18.4409 17.8359C18.3071 17.7471 15.1636 15.6357 15.1636 12.9883C15.1636 11.0293 16.7573 9.43555 18.7168 9.43555C20.6763 9.43555 22.27 11.0293 22.27 12.9883C22.27 15.6357 19.1265 17.7471 18.9927 17.8359C18.9092 17.8916 18.813 17.919 18.7168 17.919ZM18.7168 10.4356C17.3091 10.4356 16.1636 11.5811 16.1636 12.9883C16.1636 14.6982 18.0044 16.2617 18.7168 16.8018C19.4292 16.2617 21.27 14.6982 21.27 12.9883C21.27 11.5811 20.1245 10.4356 18.7168 10.4356Z"
        fill="#696969"
      />
    </svg>
  );
};

export default MileageIcon;
